import { Alert, AlertList, AlertWrapper } from "melco-ui";
import { useTranslation } from "react-i18next";
import isEmpty from "lodash-es/isEmpty";

type DisplayErrorsProps = {
  errors?: any[];
};
export const DisplayErrors: React.FC<DisplayErrorsProps> = ({ errors }) => {
  const { t } = useTranslation();
 
  return (
    <>
      <AlertWrapper>
        <Alert
          message={t("global.error.form.title")}
          type="error"
          withBackground
          description={
            !isEmpty(errors) && (
              <AlertList>
                {errors?.map((error: any) => (
                  <li key={error?.key}>{error?.message}</li>
                ))}
              </AlertList>
            )
          }
        />
      </AlertWrapper>
    </>
  );
};
